"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.RecordIdentifierEvaluator = void 0;
var identifier_1 = require("../../../../expression/javascript/node/identifier");
var nodeDef_1 = require("../../../../nodeDef");
var records_1 = require("../../../records");
var nodeValues_1 = require("../../../../node/nodeValues");
var survey_1 = require("../../../../survey");
var utils_1 = require("../../../../utils");
var nodesFinder_1 = require("./nodesFinder");
var getNodeValue = function (params) {
    var node = params.node, nodeDef = params.nodeDef, survey = params.survey;
    var value = node.value;
    if (utils_1.Objects.isEmpty(value)) {
        return null;
    }
    if (nodeDef.type === nodeDef_1.NodeDefType.code) {
        var itemUuid = nodeValues_1.NodeValues.getItemUuid(node);
        var item = itemUuid ? survey_1.Surveys.getCategoryItemByUuid({ survey: survey, itemUuid: itemUuid }) : null;
        return item ? item.props.code : null;
    }
    if (nodeDef.type === nodeDef_1.NodeDefType.taxon) {
        var taxonUuid = nodeValues_1.NodeValues.getTaxonUuid(node);
        var taxon = taxonUuid ? survey_1.Surveys.getTaxonByUuid({ survey: survey, taxonUuid: taxonUuid }) : null;
        return taxon ? taxon.props.code : null;
    }
    switch (nodeDef.type) {
        case nodeDef_1.NodeDefType.decimal:
        case nodeDef_1.NodeDefType.integer:
            return Number(value);
        case nodeDef_1.NodeDefType.boolean:
            return value === 'true';
        default:
            return value;
    }
};
var getNodesOrValues = function (params) {
    var survey = params.survey, nodeDefReferenced = params.nodeDefReferenced, referencedNodes = params.referencedNodes, propName = params.propName, evaluateToNode = params.evaluateToNode;
    var single = !nodeDefReferenced.props.multiple;
    if (single) {
        if (referencedNodes.length === 0)
            throw new Error("Cannot find node for definition with name ".concat(propName));
        if (referencedNodes.length > 1)
            throw new Error("Multiple nodes found for definition with name ".concat(propName));
    }
    if (nodeDefReferenced.type === nodeDef_1.NodeDefType.entity || evaluateToNode) {
        return single ? referencedNodes[0] : referencedNodes;
    }
    var values = referencedNodes.map(function (referencedNode) {
        return getNodeValue({ survey: survey, node: referencedNode, nodeDef: nodeDefReferenced });
    });
    return single ? values[0] : values;
};
var RecordIdentifierEvaluator = (function (_super) {
    __extends(RecordIdentifierEvaluator, _super);
    function RecordIdentifierEvaluator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecordIdentifierEvaluator.prototype.evaluate = function (expressionNode) {
        try {
            var result = _super.prototype.evaluate.call(this, expressionNode);
            return result;
        }
        catch (e) {
        }
        var propName = expressionNode.name;
        var _a = this.context, survey = _a.survey, record = _a.record, evaluateToNode = _a.evaluateToNode, nodeContext = _a.object;
        var nodeDefContextUuid = nodeContext.nodeDefUuid, value = nodeContext.value;
        if (!nodeDefContextUuid) {
            throw new Error("Cannot find node with name ".concat(propName, ": context object is not a Node"));
        }
        var nodeDefContext = survey_1.Surveys.getNodeDefByUuid({ survey: survey, uuid: nodeDefContextUuid });
        if (value && value[propName] !== undefined) {
            return value[propName];
        }
        if (nodeValues_1.NodeValues.isValueProp({ nodeDef: nodeDefContext, prop: propName })) {
            return nodeValues_1.NodeValues.getValueProp({ nodeDef: nodeDefContext, node: nodeContext, prop: propName });
        }
        var nodeDefReferenced = survey_1.Surveys.getNodeDefByName({ survey: survey, name: propName });
        if (nodeContext.nodeDefUuid === nodeDefReferenced.uuid) {
            return nodeContext;
        }
        if (survey_1.Surveys.isNodeDefAncestor({ nodeDefAncestor: nodeDefReferenced, nodeDefDescendant: nodeDefContext })) {
            try {
                return records_1.Records.getAncestor({ record: record, node: nodeContext, ancestorDefUuid: nodeDefReferenced.uuid });
            }
            catch (e) {
                throw new Error("Could not find ancestor with def ".concat(nodeDefReferenced.props.name, " - node def descendant: ").concat(nodeDefContext.props.name, " - ancestor h: ").concat(nodeDefReferenced.meta.h, " descendant h : ").concat(nodeDefContext.meta.h));
            }
        }
        var referencedNodes = nodesFinder_1.NodesFinder.findDescendants({ survey: survey, record: record, nodeContext: nodeContext, nodeDefReferenced: nodeDefReferenced });
        return getNodesOrValues({ survey: survey, referencedNodes: referencedNodes, nodeDefReferenced: nodeDefReferenced, propName: propName, evaluateToNode: evaluateToNode });
    };
    return RecordIdentifierEvaluator;
}(identifier_1.IdentifierEvaluator));
exports.RecordIdentifierEvaluator = RecordIdentifierEvaluator;
//# sourceMappingURL=identifier.js.map